<template>
  <div class="steps">
    <div class="step-item" v-for="(step, index) in steps" :key="step.title" :class="classSteps(index+1)">
      <div class="step-marker">
        <span class="icon">
          <i :class="step.icon"></i>
        </span>
      </div>
      <div class="step-details">
        <p class="step-title">{{ step.title }}</p>
        <p>{{ step.detail }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    step: Number
  },
  data () {
    return {
      steps: [
        {
          title: 'Step 1',
          detail: 'เลือกระดับขั้นที่ท่านต้องการ',
          icon: 'fa fa-check'
        },
        {
          title: 'Step 2',
          detail: 'เลือกวิธีการชำระเงิน',
          icon: 'fa fa-check'
        },
        {
          title: 'Step 3',
          detail: 'ชำระเงินและแนบหลักฐาน',
          icon: 'fa fa-check'
        },
        {
          title: 'Step 4',
          detail: 'รอการอนุมัติจากผู้ดูแล',
          icon: 'fa fa-flag'
        }
      ]
    }
  },
  methods: {
    classSteps (value) {
      return {
        'is-active': this.step === value,
        'is-completed': this.step > value,
        'is-success': this.step > value
      }
    }
  }
}
</script>
